// import axios from 'axios'
export default {
    namespaced: true,    
    state: {
        obj: {},
        objs: [],
        uom: ['kg','pcs','botol']
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload
        },
        setObj(state, pload) {
            state.obj = pload
        },
    },
    actions: {
        getObjs({rootState, commit}){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "variants"
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then (response => {
                    commit('setObjs', response.data.data)
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        },
        duplicateVariantDetails({rootState}, payload){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "others/duplicatevariantdetails/" + payload.variant_name + "/" + payload.variant_code
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then (response => {
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        },
        getObj({rootState, commit}, code){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "variants/" + code
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then (response => {
                    commit('setObj', response.data.data)
                    resolve(response.data.data)
                }, error => {
                    reject(error)
                })
            })
        },
        getObjSize({rootState, commit}, size){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "variants/get-by-size/" + size
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then (response => {
                    commit('setObjs', response.data.data)
                    resolve(response.data.data)
                }, error => {
                    reject(error)
                })
            })
        },

    },
}